import router                               from '@/router';
import store                                from '@/store';
import { useField, useFieldArray, useForm } from 'vee-validate';
import { computed, ref}                     from "vue";
import { useRoute }                         from 'vue-router'
import { VDataTable }                       from 'vuetify/labs/VDataTable'
import * as yup                             from 'yup';
import QuestionDataService                  from './services/QuestionDataService';
import VeeQuill                             from '@/components/VeeQuill'
import VeeRadio                             from '@/components/VeeRadio.vue';
import VeeSelect                            from '@/components/VeeSelect.vue';

export default {

    name: 'Questionario',
    components: { VDataTable, VeeQuill, VeeRadio, VeeSelect },

    data: () => ({
        altsName: ['A', 'B', 'C', 'D', 'E'],
        btnName: 'Salvar',
        dialogDelete: false,
        headers: [
            { title: 'Nome', key: 'nome', align: 'start', width: '60%' },
            { title: 'Questões', key: 'perguntas.length', align: 'center', width: '10%' },
            { title: 'Criação', key: 'datetime', align: 'center', width: '15%' },
            { title: 'Ações', key: 'id', align: 'center', sortable: false, width: '15%' },
        ],
        isFormValid: false,
        idQuestion: null,
        listQuestions: [],
        loading: true,
        sortBy: [{ key: 'datetime', order: 'desc' }],
    }),

    setup() {
        const alert     = ref(false);
        const alertText = ref('');
        const alertType = ref(null);
        const difficultyItems = ref([
            { value: '1', title: '1 - Muito facil' },
            { value: '2', title: '2 - Facil' },
            { value: '3', title: '3 - Media' },
            { value: '4', title: '4 - Dificil' },
            { value: '5', title: '5 - Muito dificil' },
        ]);
        const items     = ref([
            { value: '4', title: '4' },
            { value: '5', title: '5' },
        ]);
        const loadingQ = ref(false);
        const qtdAlt    = ref(4);
        const route     = useRoute();
        const sbColor   = ref('success');
        const sbMessage = ref('');
        const snackbar  = ref(false);
        
        const validationSchema = yup.object().shape({
            nome: yup.string().required('Campo obrigatório.').min(2, 'O nome precisa ter pelo menos 2 caracteres.'),
            Questions: yup.array().of(
                yup.object().shape({
                    question: yup.string().required('Campo obrigatório.'),
                    altTrue: yup.string().required('Campo obrigatório.'),
                    difficulty: yup.string().oneOf(['1', '2', '3', '4', '5']).required('Campo obrigatório.'),
                    answers: yup.array().of(
                        yup.object().shape({
                            answer: yup.string().required('Campo obrigatório.')
                        })
                    )
                })
            ),
        });

        const { handleSubmit, handleReset } = useForm({ 
            validationSchema
        });
    
        const nome = useField('nome', validationSchema);
        const {remove, push, fields: questions} = useFieldArray('Questions', validationSchema);

        const onSubmit = handleSubmit(async (values) => {
            loadingQ.value = true;
            if (route.params.qPage === 'Criar') {
                await QuestionDataService.create({usuario: store.state.userId, nome: values.nome, perguntas: values.Questions}).then(response => {
                    alertType.value = 'success';
                    alertText.value = 'Questionário cadastrado com sucesso!';
                    sbColor.value   = alertType.value;
                    sbMessage.value = alertText.value;
                    router.push({ name: 'questionarios', params: { qPage: 'Listar' } });
                }).catch(error => {
                    alertType.value = 'error';
                    alertText.value = error.message;
                    sbColor.value   = alertType.value;
                    sbMessage.value = alertText.value;
                })
                handleReset();
            }
            else if (route.params.qPage === 'Editar') {
                await QuestionDataService.update({id: route.params.idQuestion, nome: values.nome, perguntas: values.Questions}).then(response => {
                    alertType.value = 'success';
                    alertText.value = 'Questionário alterado com sucesso!';
                    sbColor.value   = alertType.value;
                    sbMessage.value = alertText.value;
                }).catch(error => {
                    alertType.value = 'error';
                    alertText.value = error.message;
                    sbColor.value   = alertType.value;
                    sbMessage.value = alertText.value;
                })
            }
            alert.value    = true;
            snackbar.value = true;
            loadingQ.value = false;
        });

        const computedQtdAlt = computed(() => {
            return Array.from({ length: qtdAlt.value }, (_, index) => index);
        });

        const createEmptyQuestion = () => ({
            altTrue: '',
            answers: Array.from({ length: qtdAlt.value }, () => ({ answer: '<p></p>' })),
            difficulty: '3',
            question: '<p></p>',
        });

        return {
            alert,
            alertType,
            alertText,
            sbColor,
            sbMessage,
            snackbar,
            loadingQ,
            nome,
            items,
            difficultyItems,
            qtdAlt,
            computedQtdAlt,
            questions,
            push,
            remove,
            onSubmit,
            handleReset,
            createEmptyQuestion,
        };
    },

    mounted() {
        this.handlePageChange(this.currentParamsPage);
    },

    computed: {
        currentParamsPage() {
            return this.$route.params.qPage;
        }
    },

    watch: {
        alert(new_val){
            if(new_val){
              setTimeout(()=>{this.alert=false}, 5000)
            }
        }, 
        currentParamsPage(newVal, oldVal) {
            this.handlePageChange(newVal);
        },
    },

    methods: {

        closeDelete () {
            this.dialogDelete = false
        },

        deleteQuestionAsk(id) {
            this.dialogDelete = true;
            this.idQuestion = id;
        },
    
        async deleteQuestionConfirm(id) {
            await QuestionDataService.delete(id).then(response => {
                this.sbMessage = 'O questionário foi excluído!';
                this.snackbar  = true;
            }).catch(error => {
                this.sbColor   = 'error';
                this.sbMessage = 'Erro ao excluir o questionário!';
                this.snackbar  = true;
            })
            await this.getQuestions();
            this.closeDelete()
        },

        editQuestion(id) {
            router.push({path: '/Questionario/Editar/'+id});
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            // Then specify how you want your dates to be formatted
            return new Intl.DateTimeFormat('pt-BR', {timeZone: 'America/Sao_Paulo'}).format(date);
        },

        normalizeQuestionPayload(question) {
            return {
                ...question,
                difficulty: ['1', '2', '3', '4', '5'].includes(String(question?.difficulty || ''))
                    ? String(question.difficulty)
                    : '3',
            };
        },

        async getQuestion(id) {
            await QuestionDataService.read(id).then(response => {
                this.nome.value.value = response.data.nome;
                this.qtdAlt = response.data.perguntas[0].answers.length
                for (let i = 0; i < response.data.perguntas.length; i++) {
                    this.push(this.normalizeQuestionPayload(response.data.perguntas[i]));
                }
            }).catch(error => {
                router.push({path: '/Questionarios/Listar/'});
                this.sbColor   = 'error';
                this.sbMessage = error.message;
                this.snackbar  = true;
            })
        },

        async getQuestions() {
            await QuestionDataService.list().then(response => {
                this.listQuestions = response.data;
                this.loading       = false;
            }).catch(error => {
                console.log(error);
            })
        },

        async handlePageChange(page) {
            this.alert = false;
            this.handleReset();
            while(this.questions.length > 0) {
                this.remove();
            }
            if(page === 'Criar') {
                this.qtdAlt  = 4;
                this.btnName = 'Salvar';
                this.push(this.createEmptyQuestion());
            }
            else if(page === 'Editar') {
                this.getQuestion(this.$route.params.idQuestion);
                this.btnName = 'Alterar';
            }
            else if(page === 'Listar') {
                this.getQuestions();
            }
        },

        addQuestion() {
            this.push(this.createEmptyQuestion());
        }
    },
};
